import { create } from 'zustand';

type TranslatingProject = {
  projectId: string | undefined;
  language: string;
  length: number;
  source: 'questions' | 'transcripts';
};

type State = {
  translatingProjects: TranslatingProject[];
};

type Action = {
  setTranslatingProjects: (
    updater: TranslatingProject[] | ((prev: TranslatingProject[]) => TranslatingProject[]),
  ) => void;
};

const useTranslationsLoadingStore = create<State & Action>((set) => ({
  translatingProjects: [],
  setTranslatingProjects: (updater) =>
    set((state) => ({
      translatingProjects:
        typeof updater === 'function' ? updater(state.translatingProjects) : updater,
    })),
}));

export default useTranslationsLoadingStore;
